<template>
  <ContentWrap
    ><el-form inline class="-mb-15px"
      ><el-form-item label="活动"
        ><el-select v-model="activityId" filterable class="!w-320px" @change="load"
          ><el-option
            v-for="a in activities"
            :key="a.id"
            :label="a.title"
            :value="a.id" /></el-select
      ></el-form-item>
      <el-form-item>
        <el-button type="primary" :disabled="!activityId" @click="open()">
          <Icon icon="ep:plus" />新建渠道
        </el-button>
      </el-form-item></el-form
    ><el-table :data="rows" v-loading="loading" border
      ><el-table-column prop="name" label="渠道名称" /><el-table-column
        prop="channelCode"
        label="渠道码"
      /><el-table-column prop="promoterId" label="推广人ID" /><el-table-column
        prop="visitCount"
        label="访问数"
      /><el-table-column prop="signupCount" label="报名数" /><el-table-column label="转化率"
        ><template #default="s"
          >{{
            s.row.visitCount ? ((s.row.signupCount / s.row.visitCount) * 100).toFixed(1) : '0.0'
          }}%</template
        ></el-table-column
      ><el-table-column label="操作" width="220"
        ><template #default="s"
          ><el-button link type="primary" @click="copyLink(s.row)">复制链接</el-button
          ><el-button link type="primary" @click="open(s.row)">编辑</el-button
          ><el-button link type="danger" @click="del(s.row.id)">删除</el-button></template
        ></el-table-column
      ></el-table
    ></ContentWrap
  ><Dialog v-model="visible" :title="form.id ? '编辑渠道' : '新建渠道'" width="480px"
    ><el-form :model="form" label-width="100px"
      ><el-form-item label="渠道名称"><el-input v-model="form.name" /></el-form-item
      ><el-form-item label="推广人ID"
        ><el-input-number v-model="form.promoterId" :min="0" /></el-form-item
      ><el-form-item label="状态"
        ><el-switch
          v-model="form.status"
          :active-value="0"
          :inactive-value="1" /></el-form-item></el-form
    ><template #footer
      ><el-button @click="visible = false">取消</el-button
      ><el-button type="primary" @click="save">保存</el-button></template
    ></Dialog
  >
</template>
<script setup lang="ts">
import * as Api from '@/api/activity/channel'
import * as ActivityApi from '@/api/activity/activity'
const message = useMessage()
const activities = ref<any[]>([]),
  rows = ref<any[]>([]),
  activityId = ref<number>(),
  loading = ref(false),
  visible = ref(false)
const form = reactive<any>({ id: undefined, name: '', promoterId: 0, status: 0 })
const load = async () => {
  if (!activityId.value) return
  loading.value = true
  try {
    rows.value = (await Api.list(activityId.value)) || []
  } finally {
    loading.value = false
  }
}
const open = (r?: any) => {
  Object.assign(form, r || { id: undefined, name: '', promoterId: 0, status: 0 })
  visible.value = true
}
const save = async () => {
  const d = { ...form, activityId: activityId.value }
  form.id ? await Api.update(d) : await Api.create(d)
  message.success('保存成功')
  visible.value = false
  load()
}
const del = async (id: number) => {
  await message.confirm('确定删除该渠道？')
  await Api.remove(id)
  load()
}
const copyLink = async (r: any) => {
  const url = `${location.origin}/activity/activity_detail?id=${activityId.value}&channelCode=${r.channelCode}`
  await navigator.clipboard.writeText(url)
  message.success('链接已复制')
}
onMounted(async () => {
  activities.value = (await ActivityApi.getActivityListAll()) || []
  if (activities.value.length) {
    activityId.value = activities.value[0].id
    load()
  }
})
</script>
